export default {
  fonts: {
    main: 'source sans pro, sans-serif',
    code: 'Fira Code, monospace',
    roboto: 'Roboto',
    karla: 'Karla',
  },
  colors: {
    main1: 'hsl(207,70%,59%)',
    main2: 'hsl(207,70%,94%)',
    dark: '#0f161e',
    dark1: '#03111b',
    dark2: 'hsl(227,2%,16%)',
    dark3: '#d3d4d4',
    dark4: '#1f3341',
    light1: 'hsl(0,0%,97%)',
    light2: 'hsl(0,0%,99%)',
    blue: '#2496ed',
    lightBlue: '#f4fafe',
    white: '#ffffff',
  },
  breakpoints: {
    mobile: 'only screen and (max-width: 576px)',
    tablet: 'only screen and (max-width: 1024px)',
  },
  spacings: {
    xxSmall: '0.25rem',
    xSmall: '0.5rem',
    small: '1rem',
    medium: '2rem',
    large: '3rem',
    xLarge: '4rem',
    xxLarge: '6rem',
  },
  animations: {
    button: 'box-shadow 0.3s ease',
    link: 'color 0.2s ease',
  },
  shadows: {
    shadow1: '0px 5px 5px 5px rgba(30,30,31,0.05)',
    shadowDark:
      'rgba(11, 33, 74, 0.09) 0px 3px 6px 10px, rgba(11, 33, 74, 0.03) 0px -2px 2px 0px',
  },
};
